import React from 'react';
import moment from 'moment-timezone';
import 'moment/locale/ja';
import { showDelayMinutes, delayMinutesStr } from '../../services/delayService';

const ContainerInfo = ({ delay, setOpen, setDateLabel, setSlotLabel, setDelayMinutes, parentIndex, currentTime, eventsEmit }) => {
  const formatDate = (date) => {
    return moment(date, 'YYYY-MM-DD').locale('ja').format('YYYY年M月D日（ddd）');
  };

  const eventsEmitDay = (date) => {
    return moment(date, 'YYYY-MM-DD').locale('ja').format('MM-DD');
  };

  const dateLabel = formatDate(delay.date);
  const handleOpen = (slotLabel, delayMinutes, eventName, eventValue) => {
    eventsEmit(eventName, eventValue);
    setDateLabel(dateLabel);
    setSlotLabel(slotLabel);
    setDelayMinutes(delayMinutes);
    setOpen(true);
  };

  const isShowDelayMinutes = (slotLabel) => {
    if (formatDate(currentTime) === dateLabel) {
      switch (slotLabel) {
        case slotLabels[0]:
          return currentTime.hour() >= 4;
        case slotLabels[1]:
          return currentTime.hour() >= 10;
        case slotLabels[2]:
          return currentTime.hour() >= 17;
      }
    } else {
      return true;
    }
  };

  const slotLabels = ['初電〜10時', '10時〜17時', '17時〜終電']

  return (
    <div className="container-info">
      <div className="date">
        <h2>{dateLabel}</h2>
      </div>

      <div className="time-list">
        {slotLabels.map((slotLabel, index) => (
          <div key={`${parentIndex}_${index}`} className="time">
            <p>{slotLabel}</p>
            {isShowDelayMinutes(slotLabel) && (
              delay.delay_minutes[index] > 0
                ? (
                    <span
                      className="delay-time"
                      id="open-modal"
                      onClick={
                        () => handleOpen(
                          slotLabel,
                          delay.delay_minutes[index],
                          'delay_certificate_list.link',
                          {
                            day: eventsEmitDay(delay.date),
                            time: slotLabels.indexOf(slotLabel),
                            delay_time: delayMinutesStr(delay.delay_minutes[index])
                          }
                        )
                      }
                    >
                      {showDelayMinutes(delay.delay_minutes[index])}
                    </span>
                  )
                : <p className="delay-time">-</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContainerInfo;
